var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.prefetching),expression:"prefetching"}],staticClass:"card-plain team-container"},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }